/**
 * @class ColorantBatchNumber
 */
export default class ColorantBatchNumber {
    /**
     * @param {Number} id
     * @param {Object} colorant
     * @param {String} batchNumber
     * @param {String} productionDate
     * @param {String} moreInfo
     * @param {Number} statusId
     * @param {String} lastStatusChange
     */
    constructor(id, colorant, batchNumber, productionDate, moreInfo, statusId, lastStatusChange) {
        this._id = id;
        this._colorant = colorant;
        this._batchNumber = batchNumber;
        this._productionDate = productionDate ? new Date(productionDate) : null;
        this._moreInfo = moreInfo;
        this._statusId = statusId;
        this._lastStatusChange = lastStatusChange ? new Date(lastStatusChange) : null;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - ColorantBatchNumber");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Object}
     */
    get colorant() {
        return this._colorant;
    }

    /**
     * @param {Object} colorant
     */
    set colorant(colorant) {
        this._colorant = colorant;
    }

    /**
     * @return {String}
     */
    get batchNumber() {
        return this._batchNumber;
    }

    /**
     * @param {String} batchNumber
     */
    set batchNumber(batchNumber) {
        this._batchNumber = batchNumber;
    }

    /**
     * @return {Date}
     */
    get productionDate() {
        return this._productionDate;
    }

    /**
     * @param {String} productionDate
     */
    set productionDate(productionDate) {
        this._productionDate = new Date(productionDate);
    }

    /**
     * @return {String}
     */
    get moreInfo() {
        return this._moreInfo;
    }

    /**
     * @param {String} moreInfo
     */
    set moreInfo(moreInfo) {
        this._moreInfo = moreInfo;
    }

    /**
     * @return {number}
     */
    get statusId() {
        return this._statusId;
    }

    /**
     * @param {number} statusId
     */
    set statusId(statusId) {
        this._statusId = statusId;
    }

    /**
     * @return {Date}
     */
    get lastStatusChange() {
        return this._lastStatusChange;
    }

    /**
     * @param {String} lastStatusChange
     */
    set lastStatusChange(lastStatusChange) {
        this._lastStatusChange = new Date(lastStatusChange);
    }

    /**
     * @return {String}
     */
    toString() {
        return "ColorantBatchNumber (" + this._id + this._batchNumber + this._colorant + ")";
    }
}
